module.exports = __webpack_public_path__ + "img/Oak V3 960x540.f8d39d5f.png";